import { render, staticRenderFns } from "./videoadd.vue?vue&type=template&id=59994e7c&scoped=true&"
import script from "./videoadd.vue?vue&type=script&lang=js&"
export * from "./videoadd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59994e7c",
  null
  
)

export default component.exports